export const IELTS_SECTION_ORDER = ['Listening', 'Reading', 'Writing', 'Speaking'];

export const IELTS_SECTION_DURATIONS = {
  Listening: 32,
  Reading: 60,
  Writing: 60,
  Speaking: 15,
};

export function prepareIeltsFullTestSections(groupedTests, includeSpeaking) {
  const allSections = (Array.isArray(groupedTests) ? groupedTests : [])
    .map((test) => {
      const categoryName = IELTS_SECTION_ORDER.find(
        (category) => category.toLowerCase() === String(test?.category_name || '').trim().toLowerCase()
      );
      return categoryName ? { ...test, category_name: categoryName } : null;
    })
    .filter(Boolean)
    .sort(
      (a, b) => IELTS_SECTION_ORDER.indexOf(a.category_name) - IELTS_SECTION_ORDER.indexOf(b.category_name)
    );

  const sections = includeSpeaking
    ? allSections
    : allSections.filter((test) => test.category_name !== 'Speaking');
  const totalDuration = sections.reduce((total, test) => {
    const configuredDuration = test.category_name === 'Listening'
      ? IELTS_SECTION_DURATIONS.Listening
      : Number(test.total_time);
    return total + (
      Number.isFinite(configuredDuration) && configuredDuration > 0
        ? configuredDuration
        : IELTS_SECTION_DURATIONS[test.category_name]
    );
  }, 0);

  return { allSections, sections, totalDuration };
}
